export const setCookie = (key: string, value: string) => {
  localStorage.setItem(key, value)
}
export const getCookie = (key: string): string => {
  return localStorage.getItem(key) || ""
}
export const deleteCookie = (key: string) => {
  localStorage.removeItem(key)
}
